jQuery('span.custom_step').click(function(){
    jQuery(this).toggleClass('active');
    var parent_item = jQuery(this).parents('.columns_static_custom_item');
    parent_item.find('.columns_static_custom_info_custom2').slideToggle();
});

$(document).on("click", '.subscription_item', function(e) {
$(this).parents('.custom_buy_box_lp').find('.subscription_item').removeClass('active');  
$(this).addClass('active');  
var selected_tab = $(this).attr('data_tab');
var form_input = $(this).parents('.custom_buy_box_lp').find('input[name="id"]');
var selling_plan = $('.selling_plans_select select').val();
var selling_input = $(this).parents('.custom_buy_box_lp').find('input[name="selling_plan"]');
if (selling_input.length){
} else {
form_input.after('<input type="hidden" name="selling_plan" value="">');
}
if (selected_tab == '2'){
selling_input.val(selling_plan);
} else {
selling_input.val('');
}


var price = $('.subscription_item.active .hk_og_price').eq(0).text();
$('.section-store--atc-price').text(price);
});

$(document).on("change", '.custom_buy_quantity input.quantity__input', function(e) {
var quantity = $(this).val();
$('input.product-quantity').val(quantity);
});


$(document).on("change", '.product-form__input input[type=radio]', function(e) {
var variant_id = $(this).parents('.product__info-container').find('input.product-variant-id').val();
$('.variant_trigger').hide();
$('.variant_trigger[data_tab="'+variant_id+'"]').show();
});

$(document).on("change", '.selling_plans_select select', function(e) {
var selling_plan = $('.selling_plans_select select').val();
$('.selling_plan_trigger').hide();
$('.selling_plan_trigger[data_tab="'+selling_plan+'"]').show();
});


$(window).on('scroll', function () {
  var $section = $('.trigger_sticky_scroll');
  var sectionBottom = $section.offset().top + $section.outerHeight();
  var scrollTop = $(window).scrollTop();

  if (scrollTop >= sectionBottom) {
    $section.addClass('sticky_active');
  } else {
    $section.removeClass('sticky_active');
  }
});

